// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ScreenSMMin":"(min-width: 768px)","wrapperFloatCard":"G4649ae","card":"G37b933","smallScreensOnly":"G06a2fd","isHidden":"G9cc955"};